<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="550"
    [nzVisible]="isVisibleRepsDrawer" [nzTitle]="repsDrawerTitle" [nzFooter]="footerTpl" (nzOnClose)="handleCancel()">
    <form nz-form *nzDrawerContent [formGroup]="_fS.repsForm">


        <div class="upload">
            <nz-avatar (click)="file.click()" (change)="onFileChanged($event)" nzIcon="user" [nzSize]="94"
                [nzSrc]="this.uploadResult ? this.uploadResult : null">
            </nz-avatar>

            <div class="pl-15" nzMultiple="false" (click)="file.click()" (change)="onFileChanged($event)">
                <button nz-button nzMultiple="false" [nzLoading]="isLoadingUpload" class="update-logo-btn">
                    <i nz-icon nzType="camera" nzTheme="outline"></i>
                    Add/Update Logo
                </button>
            </div>
            <input autocomplete="off" type="file" (change)="onFileChanged($event)" #file hidden
                nzTooltipTitle="prompt text" multiple (click)="Onclick($event)"
                accept="image/png, image/gif, image/jpeg" />
            <a *ngIf="this.uploadResult" nz-popconfirm nzPopconfirmTitle="Are you sure you want to delete the logo?"
                nzPopconfirmPlacement="bottom" (nzOnConfirm)="removeLogo()"><img
                    src="../../../../assets/images/delete.png" class="delete-File ml-1" />
            </a>

        </div>
        <div nz-row [nzGutter]="8">
            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="firstNameError">
                        <label class="label-text required">First Name</label>
                        <input type="text" class="input-group" nz-input formControlName="firstName" maxlength="50"
                            minlength="2">
                        <ng-template #firstNameError let-control>
                            <ng-container *ngIf="control.hasError('required')">First Name is required</ng-container>
                            <ng-container *ngIf="control.hasError('minlength')">First Name
                                {{validationMessage.minlength}}</ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
        <div nz-row [nzGutter]="8">
            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="lastNameError">
                        <label class="label-text required">Last Name</label>
                        <input type="text" class="input-group" nz-input formControlName="lastName" maxlength="50"
                            minlength="2">
                        <ng-template #lastNameError let-control>
                            <ng-container *ngIf="control.hasError('required')">Last Name is required</ng-container>
                            <ng-container *ngIf="control.hasError('minlength')">Last Name
                                {{validationMessage.minlength}}</ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
        <div nz-row [nzGutter]="8">
            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="mobileNumberError">
                        <label class="label-text">Mobile Number</label>
                        <nz-input-group>
                            <input type="tel" class="input-group" nz-input formControlName="mobileNumber" maxlength="14"
                                placeholder="(555) 555-5555" (keypress)="_cS.checkNumbers($event)"
                                mask="(000) 000-0000">
                        </nz-input-group>
                        <ng-template #mobileNumberError let-control>
                            <ng-container *ngIf="control.hasError('required')">Mobile Number is required</ng-container>
                            <ng-container *ngIf="control.hasError('invalidPhoneFormat')">Please enter a valid 10-digit
                                phone number</ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
        <div nz-row [nzGutter]="8">
            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="titleError">
                        <label class="label-text">Title</label>
                        <input type="text" class="input-group" nz-input formControlName="title" maxlength="100"
                            minlength="2">
                        <ng-template #titleError let-control>
                            <ng-container *ngIf="control.hasError('minlength')">Title
                                {{validationMessage.minlength}}</ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
        <div nz-row [nzGutter]="8">
            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="LocationError">
                        <label class="label-text">Location</label>
                        <input type="text" class="input-group" nz-input formControlName="location" maxlength="50"
                            minlength="2">
                        <ng-template #LocationError let-control>
                            <ng-container *ngIf="control.hasError('minlength')">Location
                                {{validationMessage.minlength}}</ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
        <div nz-row [nzGutter]="8">
            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="linkedInProfilelnkError">
                        <label class="label-text">LinkedIn profile link</label>
                        <input type="text" pattern="http(s)?:\/\/([\w]+\.)?linkedin\.com\/in\/[A-z0-9_-]+\/?"
                            class="input-group" nz-input formControlName="linkedInProfilelnk" maxlength="256"
                            minlength="2">
                        <ng-template #linkedInProfilelnkError let-control>
                            <ng-container *ngIf="control.hasError('minlength')">LinkedIn profile link
                                {{validationMessage.minlength}}</ng-container>
                            <ng-container *ngIf="control.hasError('pattern')">Please enter valid linkedIn profile link
                            </ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
        <ng-container *ngIf="selectedRepsData.isSupplierEdited">
            <div nz-col nzSpan="24">
                <nz-form-item class="form-item-with-margin">
                    <nz-form-control>
                        <label class="retail-program-label-text retail-program-title"> Retail Programs
                        </label>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <nz-skeleton *ngIf="isRetailProgramsLoading" [nzParagraph]="{ rows: 5}" [nzActive]="true"></nz-skeleton>
            <ng-container *ngFor="let data of retailProgramsList">
                <div nz-col nzSpan="24">
                    <nz-form-item class="form-item-checkbox">
                        <nz-form-control>
                            <label nz-checkbox [(ngModel)]="data.isChecked" [ngModelOptions]="{ standalone: true }"
                                (ngModelChange)="retailProgramsChange($event,data)">{{data.name}}</label>
                        </nz-form-control>
                    </nz-form-item>
                </div>
            </ng-container>
        </ng-container>
    </form>
    <ng-template #footerTpl>
        <div class="d-flex justify-content-end">
            <button nz-button nzType="primary" (click)="handleOk()" [nzLoading]="isLoadingOne"
                class="medium-btn small-btn width-100 mr-1">Update</button>
            <button nz-button nzType="default" (click)="handleCancel()" class="dlt-btn width-100">Cancel</button>
        </div>
    </ng-template>
</nz-drawer>